var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "rootContainerCutline" }, [
      _c("div", { staticClass: "line line-t start" }),
      _c("div", { staticClass: "line line-t end" }),
      _c("div", { staticClass: "line line-b start" }),
      _c("div", { staticClass: "line line-b end" }),
      _c("div", { staticClass: "line line-r start" }),
      _c("div", { staticClass: "line line-r end" }),
      _c("div", { staticClass: "line line-l start" }),
      _c("div", { staticClass: "line line-l end" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }